import type { Interceptor } from "@connectrpc/connect";
import { getBackend } from "@/app/services/backend";
import type { AuthSession } from "@/app/services/backend";
import { getRuntimeEnvVar } from "@/app/services/runtimeEnv";

export { getRuntimeEnvVar };

export const BFF_URL = getRuntimeEnvVar(
  "VITE_BFF_URL",
  import.meta.env.VITE_BFF_URL,
  "http://localhost:8080"
);

interface AuthInterceptorOptions {
  getSessionId?: () => string | null;
  getTaskId?: () => string | null;
  getSimId?: () => string | null;
  includeLegacySessionHeader?: boolean;
  includeLegacyTaskHeader?: boolean;
}

export function createAuthInterceptor(options: AuthInterceptorOptions = {}): Interceptor {
  const {
    getSessionId,
    getTaskId,
    getSimId,
    includeLegacySessionHeader = false,
    includeLegacyTaskHeader = false,
  } = options;

  return (next) => async (req) => {
    let session: AuthSession | null = null;
    try {
      const backend = await getBackend();
      session = await backend.auth.getSession();
    } catch (err) {
      // 세션 조회 실패는 인증 헤더 없이 진행 — 거부 여부는 서버가 판단
      console.warn("[connectCommon] Failed to get session:", err);
    }
    if (session?.accessToken) {
      req.header.set("Authorization", `Bearer ${session.accessToken}`);
    }
    if (session?.user.id) {
      req.header.set("x-auth-user-id", session.user.id);
    }

    const sessionId = getSessionId?.();
    if (sessionId) {
      req.header.set("X-Session-Id", sessionId);
      if (includeLegacySessionHeader) {
        req.header.set("session_id", sessionId);
      }
    }

    const taskId = getTaskId?.();
    if (taskId) {
      req.header.set("X-Task-Id", taskId);
      if (includeLegacyTaskHeader) {
        req.header.set("task_id", taskId);
      }
    }

    const simId = getSimId?.();
    if (simId) {
      req.header.set("X-Simulation-Id", simId);
    }

    return await next(req);
  };
}
